// Configuration for in-app widget previews.
// Customize this file to change the fake data shown in the settings preview panels.

export default {
	// Avatar image URLs to use for fake preview chatters.
	// Leave empty to auto-generate colored initials avatars from usernames.
	// Example: ['https://example.com/avatar1.png', 'https://example.com/avatar2.png']
	avatarUrls: [],

	// Fake usernames shown in preview messages
	usernames: [
		'streamfan99', 'coolviewer', 'xXgamerXx', 'viewer_42', 'lurker2023',
		'hypetrain99', 'nightwatcher', 'subscriber1', 'mod_alice', 'TheRealDeal',
		'retrogamer', 'kawaiichan', 'pro_sniper', 'PixelPusher', 'noodlemaster',
	],
	usernamesBrown: [
		'pooBandit99', 'fartBlaster', 'xXDookyKingXx', 'kaka_master42', 'peepee_lurker',
		'hyperFartTrain', 'nightPooWatcher', 'subscriberDooky', 'mod_kaka', 'TheRealFart',
		'retroPooGamer', 'kawaiipeepee', 'proFartSniper', 'PixelPooPusher', 'dookyNoodle',
	],

	// Fake chat messages shown in preview
	chatMessages: [
		'PogChamp!', 'LUL this is great', 'nice stream!', 'KEKW', 'poggers',
		'how long have you been streaming?', 'Hello from Germany!', 'pog pog pog',
		'you are amazing', 'what game is this?', '5Head great play',
		'let\'s go!', 'OMEGALUL', 'GG', 'first time watching, already love it',
		'clip that', 'monkaS', 'ayyyy the legend is here', 'NotLikeThis',
		'that was insane', 'can\'t believe that worked', 'Farts',
		'HeyGuys', 'this is so fun to watch', 'hi mom',
	],
	chatMessagesBrown: [
		'POOGERS!', 'LUL that fart was legendary', 'nice poo stream!', 'KEKW kaka moment',
		'that was a dooky', 'how long has that fart been brewing?',
		'Hello from the pee pee squad!', 'poo poo poo spam',
		'you are the fart king', 'what game is this? looks like poo simulator',
		'5Head dooky strategy', 'let’s gooo fart blast',
		'OMEGAFART', 'GG easy poo', 'first time watching, already smell the poo',
		'clip that fart', 'monkaPoo', 'ayyyy the dooky legend is here',
		'NotLikePoo', 'that fart was insane', 'can’t believe that poo worked',
		'mega fart incoming', 'HeyPoo', 'this is so fun I almost pee pee',
		'hi mom I farted',
	],
};
